import Request from './baseRequest'
import i18n from "../i18n";

const getUserToken = () => {
	return JSON.parse(localStorage.getItem('auth.currentUser')).token;
}

const _createJourney = payload => {

  const token = getUserToken()
  const config = {
    headers: {
      authorization: `Bearer ${token}`
    }
  }

  return Request.post(
    `${window.config.VUE_APP_BACKEND}/api/journeys`,
    payload,
    config
  )
}

const _getJourneys = params => { 
  const token = getUserToken()
  const config = {
    headers: {
      authorization: `Bearer ${token}`
    }
  }

  const url= params? `${window.config.VUE_APP_BACKEND}/api/journeys?${params.q}` : `${window.config.VUE_APP_BACKEND}/api/journeys`


  return Request.get(
    url,
    config
  )
}

const _deleteJourney = journeyId => {
  const token = getUserToken()
  const config = {
    headers: {
      authorization: `Bearer ${token}`
    }
  }

  return Request.delete(`${window.config.VUE_APP_BACKEND}/api/journeys/${journeyId}`, config)
}

const _getJourney = journeyId => {
  const token = getUserToken()
  const config = {
    headers: {
      authorization: `Bearer ${token}`
    }
  }

  return Request.get(`${window.config.VUE_APP_BACKEND}/api/journeys/${journeyId}`, config)
}

const _updateJourney = (journey) => {
  const token = getUserToken()
  const config = {
    headers: {
      authorization: `Bearer ${token}`
    }
  }

  return Request.put(`${window.config.VUE_APP_BACKEND}/api/journeys/${journey._id}`, journey, config)
}


// "Probar journey": ejecucion real de un journey para un customer con trace
// por paso. Ver components/journeys/test-run/.
// Con `dryRun: true` no se envia nada y las esperas siempre se aceleran; solo
// en ese modo se puede mandar `workflow` (nodos sin guardar, ej. el borrador
// de Calvin) para probarlo en lugar del journey guardado.
const _startTestRun = (journeyId, payload) => {
  const token = getUserToken()
  const config = { headers: { authorization: `Bearer ${token}` } }
  return Request.post(`${window.config.VUE_APP_BACKEND}/api/journeys/${journeyId}/test-run`, payload, config)
}

const _getTestRun = (journeyId, executionId) => {
  const token = getUserToken()
  const config = { headers: { authorization: `Bearer ${token}` } }
  return Request.get(`${window.config.VUE_APP_BACKEND}/api/journeys/${journeyId}/test-runs/${executionId}`, config)
}

const _getTestRuns = (journeyId, params) => {
  const token = getUserToken()
  const config = { headers: { authorization: `Bearer ${token}` } }
  const qs = params && params.q ? `?${params.q}` : ''
  return Request.get(`${window.config.VUE_APP_BACKEND}/api/journeys/${journeyId}/test-runs${qs}`, config)
}

const _getActiveExecution = (journeyId, params) => {
  const token = getUserToken()
  const config = { headers: { authorization: `Bearer ${token}` } }
  const qs = params && params.q ? `?${params.q}` : ''
  return Request.get(`${window.config.VUE_APP_BACKEND}/api/journeys/${journeyId}/active-execution${qs}`, config)
}

// Historial de ediciones del journey: sale de audit_logs, que ya guarda el
// arbol completo en cada guardado. La lista trae solo metadatos; el arbol de
// una version se pide aparte porque pesa decenas de KB.
const _getJourneyHistory = (journeyId, params) => {
  const token = getUserToken()
  const config = { headers: { authorization: `Bearer ${token}` } }
  const qs = params && params.q ? `?${params.q}` : ''
  return Request.get(`${window.config.VUE_APP_BACKEND}/api/journeys/${journeyId}/history${qs}`, config)
}

const _getJourneyHistoryVersion = (journeyId, versionId) => {
  const token = getUserToken()
  const config = { headers: { authorization: `Bearer ${token}` } }
  return Request.get(`${window.config.VUE_APP_BACKEND}/api/journeys/${journeyId}/history/${versionId}`, config)
}

// "Armar con Calvin": cada pedido es un run asíncrono (cola en admin-apis) que
// devuelve un borrador del workflow; el editor consulta su estado cada pocos
// segundos. Ver components/journeys/journey-calvin-modal.vue.
const journeyAiRequest = (method, path, payload) => {
  const config = { headers: { authorization: `Bearer ${getUserToken()}` } }
  const url = `${window.config.VUE_APP_BACKEND}/api/journey-ai-runs${path}`
  return method === 'get' ? Request.get(url, config) : Request.post(url, payload || {}, config)
}

export default {
  updateJourney: _updateJourney,
  deleteJourney : _deleteJourney,
  getJourney : _getJourney,
  getJourneys : _getJourneys,
  createJourney : _createJourney,
  startTestRun: _startTestRun,
  getTestRun: _getTestRun,
  getTestRuns: _getTestRuns,
  getActiveExecution: _getActiveExecution,
  getJourneyHistory: _getJourneyHistory,
  getJourneyHistoryVersion: _getJourneyHistoryVersion,
  getJourneyAiConfig: () => journeyAiRequest('get', '/config'),
  createJourneyAiRun: (payload) => journeyAiRequest('post', '', payload),
  getJourneyAiRun: (id) => journeyAiRequest('get', `/${id}`),
  listJourneyAiRuns: (query) => journeyAiRequest('get', `?${new URLSearchParams(query).toString()}`),
  cancelJourneyAiRun: (id) => journeyAiRequest('post', `/${id}/cancel`),
  applyJourneyAiRun: (id) => journeyAiRequest('post', `/${id}/apply`),
  dismissJourneyAiRun: (id) => journeyAiRequest('post', `/${id}/dismiss`)
}


const blocks = [
  {
    group : i18n.t('journeys.journey_workflow_components_groups_notifications'),
    blocks: [
      {
        preview: {
          title: i18n.t('journeys.journey_workflow_components_email'),
          icon: 'mdi-email-outline'
        },
        node: {
          title: i18n.t('journeys.journey_workflow_components_email'),
          description: 'Send an email',
          type: 'notification_email',
          icon: 'mdi-email-outline',
          color: '#50A5F1',
        },
      },
      {
        preview: {
          title: i18n.t('journeys.journey_workflow_components_app_push'),
          icon: 'mdi-cellphone-message'
        },
        node: {
          title: i18n.t('journeys.journey_workflow_components_app_push'),
          description: 'Send a push notification',
          type: 'notification_app_push',
          icon: 'mdi-cellphone-message',
          color: '#50A5F1'
        },
      },
      {
        preview: {
          title: i18n.t('journeys.journey_workflow_components_sms'),
          icon: 'mdi-message-outline'
        },
        node: {
          title: i18n.t('journeys.journey_workflow_components_sms'),
          description: 'Send a sms',
          type: 'notification_sms',
          icon: 'mdi-message-outline',
          color: '#50A5F1'
        },
      },
      {
        preview: {
          title: i18n.t('journeys.journey_workflow_components_web_push'),
          icon: 'mdi-monitor-star'
        },
        node: {
          title: i18n.t('journeys.journey_workflow_components_web_push'),
          description: 'Send a web push notification',
          type: 'notification_web_push',
          icon: 'mdi-monitor-star',
          color: '#50A5F1'
        },
      },
      {
        preview: {
          title: i18n.t('journeys.journey_workflow_components_whatsapp'),
          icon: 'mdi-whatsapp'
        },
        node: {
          title: i18n.t('journeys.journey_workflow_components_whatsapp'),
          description: 'Send a whatsapp',
          type: 'notification_whatsapp',
          icon: 'mdi-whatsapp',
          color: '#50A5F1'
        },
      },
    ]
  },
  {
    group : i18n.t('journeys.journey_workflow_components_groups_dalays'),
    blocks: [
      {
        preview: {
          title: i18n.t('journeys.journey_workflow_components_wait_for_time'),
          icon: 'mdi-calendar-clock'
        },
        node: {
          title: i18n.t('journeys.journey_workflow_components_wait_for_time'),
          description: 'Esperar por tiempo',
          type: 'delay_time',
          icon: 'mdi-calendar-clock',
          color: '#F46A6A'
        },
      },
      {
        preview: {
          title: i18n.t('journeys.journey_workflow_components_wait_for_property'),
          icon: 'mdi-database-clock-outline'
        },
        node: {
          title: i18n.t('journeys.journey_workflow_components_wait_for_property'),
          description: 'Esperar por propiedad',
          type: 'delay_condition',
          icon: 'mdi-database-clock-outline',
          color: '#F46A6A'
        },
      },
      {
        preview: {
          title: i18n.t('journeys.journey_workflow_components_wait_for_interaction'),
          icon: 'mdi-routes-clock'
        },
        node: {
          title: i18n.t('journeys.journey_workflow_components_wait_for_interaction'),
          description: 'Esperar por interacción',
          type: 'delay_condition_interaction',
          icon: 'mdi-routes-clock',
          color: '#F46A6A'
        },
      },
      {
        preview: {
          title: i18n.t('journeys.journey_workflow_components_wait_until_slot_time'),
          icon: 'mdi-timeline-clock-outline'
        },
        node: {
          title: i18n.t('journeys.journey_workflow_components_wait_until_slot_time'),
          description: 'Esperar hasta que se llegue al tiempo del slot',
          type: 'delay_slot_time',
          icon: 'mdi-timeline-clock-outline',
          color: '#F46A6A'
        },
      }
    ]
  },
  {
    group : i18n.t('journeys.journey_workflow_components_groups_flow_control'),
    blocks: [
      {
        preview: {
          title: i18n.t('journeys.journey_workflow_components_condition_simple'),
          icon: 'mdi-call-split'
        },
        node: {
          title: i18n.t('journeys.journey_workflow_components_condition_simple'),
          description: 'Condición simple',
          type: 'flow_control_condition_simple',
          icon: 'mdi-call-split',
          color: '#f1b44c'
        }
      },
      {
        preview: {
          title: i18n.t('journeys.journey_workflow_components_condition_complex'),
          icon: 'mdi-set-split'
        },
        node: {
          title: i18n.t('journeys.journey_workflow_components_condition_complex'),
          description: 'Condición simple',
          type: 'flow_control_condition_complex',
          icon: 'mdi-set-split',
          color: '#f1b44c'
        }
      },
      {
        preview: {
          title: i18n.t('journeys.journey_workflow_components_ab_testing'),
          icon: 'mdi-test-tube'
        },
        node: {
          title: i18n.t('journeys.journey_workflow_components_ab_testing'),
          description: 'Realizar A/B testing',
          type: 'flow_control_ab_testing',
          icon: 'mdi-test-tube',
          color: '#f1b44c'
        }
      },
      {
        preview: {
          title: i18n.t('journeys.journey_workflow_components_reachability'),
          icon: 'mdi-contactless-payment'
        },
        node: {
          title: i18n.t('journeys.journey_workflow_components_reachability'),
          description: 'Reachability',
          type: 'flow_control_reachability',
          icon: 'mdi-contactless-payment',
          color: '#f1b44c'
        }
      },
      {
        preview: {
          title: i18n.t('journeys.journey_workflow_components_finish'),
          icon: 'mdi-exit-to-app'
        },
        node: {
          title: i18n.t('journeys.journey_workflow_components_finish'),
          description: 'Terminar',
          type: 'flow_control_end',
          icon: 'mdi-exit-to-app'          
        }
      },

      {
        preview: {
          title: i18n.t('journeys.journey_workflow_components_cancel'),
          icon: 'mdi-cancel'
        },
        node: {
          title: i18n.t('journeys.journey_workflow_components_cancel'),
          description: 'Cancelar',
          type: 'flow_control_cancel',
          icon: 'mdi-cancel'          
        }
      }
    ]
  },
  {
    group : i18n.t('journeys.journey_workflow_components_groups_actions'),
    blocks: [
      {
        preview: {
          title: i18n.t('journeys.journey_workflow_components_api'),
          icon: 'mdi-code-braces'
        },
        node: {
          title: i18n.t('journeys.journey_workflow_components_api'),
          description: 'Invocar API',
          type: 'actions_api',
          icon: 'mdi-code-braces',
          color: "#74788d"
        }
      },
      {
        preview: {
          title: i18n.t('journeys.journey_workflow_components_script'),
          icon: 'mdi-code-tags'
        },
        node: {
          title: i18n.t('journeys.journey_workflow_components_script'),
          description: 'Script',
          type: 'actions_script',
          icon: 'mdi-code-tags',
          color: "#74788d"
        }
      }
    ]
  }
]


export {blocks}